<template>
  <div class="item" id="pg-info">
    <div class="left" data-toggle="collapse" data-target="#item-info" aria-expanded="true" aria-controls="item-info">
      <p class="text-add-course">Informações</p>
    </div>
    <div id="item-info" class="text-center rigth collapse width"  aria-labelledby="pg-info" data-parent="#pg-add-course">
      <div class="content-info">
        <div class="form-info">
          <div class="col-12 mb-3">
            <label>Qual o nome do seu curso?</label>
            <input class="form-control input-form-course" v-model="courseInfo.name" />
          </div>

          <div class="col-12 mb-3">
            <label>Descreva rapidamente o que será abordado e o publico alvo:</label>
            <input class="form-control input-form-course" v-model="courseInfo.suma" />
          </div>

          <div class="col-12 mb-3">
            <label>Agora uma descrição aprofundada do que vai ser abordado:</label>
            <textarea class="form-control input-form-course" rows="5" v-model="courseInfo.description" />
          </div>

          <div class="col-12 mb-3">
            <label>Defina o valor do Curso:</label>
            <div class="input-group">
              <span class="input-group-append input-apendice">R$</span>
              <input class="form-control input-form-course" v-model="courseInfo.value" type="number" min="0"/>
            </div>
          </div>

          <div class="col-12">
            <label>E informe a carga Horária do mesmo:</label>
            <div class="input-group">
              <input class="form-control input-form-course" v-model="courseInfo.hours" type="number" min="0"/>
              <span class="input-group-prepend input-apendice">Horas</span>
            </div>
          </div>

          <div class="d-flex justify-content-between mt-5">
            <button
              class="btn  px-3"
              data-toggle="collapse"
              data-target="#item-start"
              aria-expanded="true"
              aria-controls="item-start"
              @click="save"
            ><< Inicio</button>

            <button
              class="btn px-3"
              data-toggle="collapse"
              data-target="#item-requirements"
              aria-expanded="true"
              aria-controls="item-requirements"
              @click="save"
            >Requerimentos >></button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'add-course-info',
  computed: {
    ...mapGetters({
      courseInfo: "getNewCourseInfo"
    })
  },
  methods: {
    ...mapActions({
      setInformations: "setInfo"
    }),
    save: function () {
      this.setInformations( this.courseInfo )
    }
  }
}
</script>
